module.exports = __webpack_public_path__ + "static/img/p1.16194f89.jpg";